var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveMatches(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    stroke: "#D9622A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10066_333864)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10066_333864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0332 8.51172H4.9668C4.43368 8.51172 4 8.9454 4 9.47852C4 10.2566 4.55449 10.9075 5.28906 11.0572V13.3887C5.28906 14.2771 6.01195 15 6.90039 15H12.0996C12.9881 15 13.7109 14.2771 13.7109 13.3887V11.0572C14.4455 10.9075 15 10.2566 15 9.47852C15 8.9454 14.5663 8.51172 14.0332 8.51172ZM4.64453 9.47852C4.64453 9.30071 4.78899 9.15625 4.9668 9.15625H5.28906V10.386C4.91476 10.2525 4.64453 9.89811 4.64453 9.47852ZM13.7109 10.386V9.15625H14.0332C14.211 9.15625 14.3555 9.30071 14.3555 9.47852C14.3555 9.89811 14.0852 10.2525 13.7109 10.386Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34013 7.67965C5.41507 7.84302 5.60843 7.9114 5.76752 7.83764L12.8146 4.6152C12.9764 4.54093 13.0472 4.34927 12.9726 4.18781C12.8984 4.02606 12.7067 3.95492 12.5452 4.02982L10.1817 5.09617C9.88404 4.44876 9.11724 4.16526 8.47185 4.46423C7.82508 4.76155 7.54239 5.52614 7.83986 6.17422L5.49811 7.25226C5.33635 7.32653 5.26554 7.51787 5.34013 7.67965Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9559 5.7218C12.9559 5.54367 12.8118 5.39954 12.6337 5.39954C12.5732 5.39954 12.0351 5.40867 11.7216 5.7218C11.4088 6.03526 11.3997 6.5731 11.3997 6.63353C11.3997 6.74588 11.3607 6.99482 11.2663 7.08924C11.1769 7.17861 10.9408 7.22173 10.8105 7.22268C10.6324 7.22268 10.4883 7.36682 10.4883 7.54494C10.4883 7.72307 10.6324 7.86721 10.8105 7.86721C10.871 7.86721 11.4088 7.85808 11.722 7.54494C12.0351 7.23181 12.0442 6.69397 12.0442 6.63353C12.0442 6.52119 12.0836 6.27193 12.1777 6.17751C12.2667 6.08843 12.5024 6.04533 12.6343 6.04407C12.8121 6.04375 12.9559 5.89961 12.9559 5.7218Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7441 7.86721C12.8046 7.86721 13.3424 7.85808 13.6555 7.54494C13.9687 7.23181 13.9778 6.69397 13.9778 6.63353C13.9778 6.52119 14.0171 6.27193 14.1112 6.17751C14.2003 6.08843 14.436 6.04533 14.5679 6.04407C14.7457 6.04375 14.8895 5.89961 14.8895 5.7218C14.8895 5.54367 14.7454 5.39954 14.5673 5.39954C14.5068 5.39954 13.9687 5.40867 13.6552 5.7218C13.3424 6.03526 13.3333 6.5731 13.3333 6.63353C13.3333 6.74588 13.2943 6.99482 13.1999 7.08924C13.1105 7.17861 12.8745 7.22173 12.7442 7.22268C12.566 7.22268 12.4219 7.36682 12.4219 7.54494C12.4219 7.72307 12.566 7.86721 12.7441 7.86721Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10066_333864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(3 2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10066_333864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveMatches);
export default __webpack_public_path__ + "static/media/archive-matches.243c3bc4856f17a0b7b121724fe59131.svg";
export { ForwardRef as ReactComponent };